import React from 'react';

const BPointIcon = ({
  width = 137,
  height = 34,
  color = '#E8E9EB',
  ...props
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 366 295'
      fill='none'
      {...props}
    >
      <path
        d='M19.1558 59.7662C19.1558 43.6753 19.1558 43.6753 0 27.5844L88.1169 0V124.896C101.909 103.442 122.981 91.9481 147.117 91.9481C194.24 91.9481 225.656 129.493 225.656 185.812C225.656 250.942 181.981 295 118 295C93.8637 295 71.2598 287.721 52.487 274.312L19.1558 295V59.7662ZM88.1169 245.961C93.8637 265.5 106.89 277.76 121.448 277.76C141.753 277.76 153.63 250.558 153.63 204.584C153.63 157.461 135.623 130.26 107.273 130.26C99.2273 130.26 92.7143 132.558 88.1169 135.623V245.961Z'
        fill={color}
      />
      <path
        d='M281.656 295C259.435 295 241.812 277.9621 241.812 256.5076C241.812 233.9037 259.435 216.2803 281.656 216.2803C303.877 216.2803 321.5 233.9037 321.5 256.5076C321.5 277.9621 303.877 295 281.656 295Z'
        fill={color}
      />
      <path
        d='M281.656 185C259.435 185 241.812 167.962 241.812 146.508C241.812 123.904 259.435 106.28 281.656 106.28C303.877 106.28 321.5 123.904 321.5 146.508C321.5 167.962 303.877 185 281.656 185Z'
        fill={color}
      />
    </svg>
  );
};

export default BPointIcon;
